(function(angular){
    'use strict';

    angular.module('onvio.setup').controller('SampleTermsModalCtrl', sampleTerms);
    sampleTerms.$inject = ['$sce', '$uibModalInstance', 'TermsSetupManager', 'text'];

    function sampleTerms($sce, $uibModalInstance, TermsSetupManager, text){
        /*jshint validthis:true */
        var vm = this;
        var sampleHtml = TermsSetupManager.convertTermsTextToHtml(text);
        vm.copySample = copySample;
        vm.closeSampleModal = closeSampleModal;
        vm.sampleText = $sce.trustAsHtml(sampleHtml);

        //////////

        function copySample(){
            $uibModalInstance.close(sampleHtml);
        }

        function closeSampleModal(){
            $uibModalInstance.dismiss('close');
        }
    }
})(window.angular);
